import { StaticImageData } from 'next/image';
import React from 'react';
interface IProps {
  children: React.ReactNode;
  bgSrc?: string;
  style?: React.CSSProperties;
  className?: string;
  boxClassName?: string;
}
export const Container = (props: IProps) => {
  const { children, bgSrc, style, className, boxClassName } = props;
  const bg = bgSrc ? { backgroundImage: `url(${bgSrc})` } : {};
  return (
    <div
      className={`bg-contain bg-no-repeat ${className ? className : ''}`}
      style={{ ...bg, ...style }}
    >
      <div
        className={`max-w-5xl  mx-auto w-full mobile:px-5 desktop:px-5 ${
          boxClassName ? boxClassName : ''
        }`}
      >
        {children}
      </div>
    </div>
  );
};
